export const NotFound = () => {
  return (
    <>
      <div className="max-w-2xl mx-auto p-6 text-center">
        <h2 className="text-2xl font-semibold text-danger mb-4">Invalid Reference Link</h2>
        <p className="text-grey-200 leading-relaxed">
          The peer reference link you're trying to access is invalid or has expired. Please check
          the link in your email or contact the person who sent you this reference request.
        </p>
      </div>
    </>
  );
};
